import * as Api from '@ViewModels';

/**
 * Converts duration from string
 * @source Original location: UiUtils.ts.backup line 2048
 */
export const convertDurationFromString = (durationString: string | undefined) => {
	if (!durationString) {
		return null;
	}
	let rest = durationString;

	const parsed: Api.IMeetingDuration = {
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	};

	if (durationString.includes('.')) {
		const [days, r] = durationString.split('.');
		parsed.days = parseInt(days, 10);
		rest = r;
	}

	const [h, m, s] = rest.split(':');
	return {
		...parsed,
		hours: parseInt(h, 10),
		minutes: parseInt(m, 10),
		seconds: parseInt(s, 10),
	};
};

/**
 * Converts duration to string
 * @source Original location: UiUtils.ts.backup line 2076
 */
export const convertDurationToString = (duration: Api.IMeetingDuration) => {
	const { days, hours, minutes, seconds } = duration;
	const d = days <= 9 ? `0${days}` : days;
	const h = hours <= 9 ? `0${hours}` : hours;
	const m = minutes <= 9 ? `0${minutes}` : minutes;
	const s = seconds <= 9 ? `0${seconds}` : seconds;
	return `${d}.${h}:${m}:${s}`;
};
